export enum LeadDeletedType {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
  DELETED = 'DELETED'
}
